module.exports = __webpack_public_path__ + "static/media/code.44a1e09b.svg";